import {Component, forwardRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-form-input-number',
  templateUrl: './form-input-number.component.html',
  styleUrls: ['./form-input-number.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputNumberComponent),
      multi: true
    }
  ]
})
export class FormInputNumberComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() min: number;

  public id: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event);
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
